import {
  toWSMoneyString,
  WSBadge,
  WSFlexBox,
  WSText
} from "@wingspanhq/fe-component-library";
import { IInvoiceLineItem } from "@wingspanhq/payments/dist/interfaces";
import React from "react";
import { calculateLineItemDiscount, calculateLineItemTotal } from ".";
import { TotalsSection, TotalsSectionItem } from "../components/Totals/Totals";

export const getLineItemsTotals = (
  lineItems: IInvoiceLineItem[]
): TotalsSection => {
  const lineItemsWithDiscounts: TotalsSectionItem[] = [];

  lineItems.forEach(lineItem => {
    lineItemsWithDiscounts.push([
      <>
        <WSFlexBox.CenterY wrap="nowrap">
          <WSText color="grey700">{lineItem.description}</WSText>
          {lineItem.reimbursableExpense ? (
            <WSBadge
              color="grey500"
              singleLine
              py="NONE"
              ml="S"
              textProps={{ kind: "LabelExtraSmall", color: "white" }}
              text="Reimbursable"
            />
          ) : null}
        </WSFlexBox.CenterY>

        {lineItem.unit && (
          <WSText.Label color="grey600">
            {lineItem.quantity} {lineItem.unit}(s) @{" "}
            {toWSMoneyString(lineItem.costPerUnit)}/{lineItem.unit}
          </WSText.Label>
        )}
        {lineItem.detail && (
          <WSText.Label color="grey600">{lineItem.detail}</WSText.Label>
        )}
      </>,
      toWSMoneyString(calculateLineItemTotal(lineItem))
    ]);

    const discount = calculateLineItemDiscount(lineItem);

    if (discount) {
      lineItemsWithDiscounts.push([
        <WSText color="grey700">
          {lineItem.discount?.description}
          {lineItem.discount?.percentage
            ? ` (${lineItem.discount?.percentage}%)`
            : ""}
        </WSText>,
        toWSMoneyString(-discount)
      ]);
    }
  });

  return {
    items: lineItemsWithDiscounts
  };
};
